import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarEmoji } from '@factorialco/f0-react'
import { JobCatalogEnumsJobCatalogTreeNodeTypesEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { TreeNode } from 'modules/cost_centers/components/CostCentersStructure/types'

import { PreviewCostCenters } from './Table'

const CostCentersPreview = ({
  treeArray,
  jobStructure,
  expandJobStructure,
}: {
  treeArray: TreeNode[]
  expandJobStructure: boolean
  jobStructure?: JobCatalogEnumsJobCatalogTreeNodeTypesEnum
}) => {
  if (!expandJobStructure) {
    return (
      <Box justifyContent="center" alignItems="center" gap="s12" flexGrow>
        <F0AvatarEmoji emoji={'🍑'} size="lg" />
        <Box gap="s2" justifyContent="center" alignItems="center">
          <Text.Normal size="300" weight="semibold" color="grey1000">
            {i18n.t('finance.cost_centers_structure.preview.empty.no_dimension.title')}
          </Text.Normal>
          <Text.Normal size="200">
            {i18n.t('finance.cost_centers_structure.preview.empty.no_dimension.description')}
          </Text.Normal>
        </Box>
      </Box>
    )
  } else if (!jobStructure) {
    return (
      <Box justifyContent="center" alignItems="center" gap="s12" flexGrow>
        <F0AvatarEmoji emoji={'💼'} size="lg" />
        <Box gap="s2" justifyContent="center" alignItems="center">
          <Text.Normal size="300" weight="semibold" color="grey1000">
            {i18n.t('finance.cost_centers_structure.preview.empty.no_hierarchy.title')}
          </Text.Normal>
          <Text.Normal size="200">
            {i18n.t('finance.cost_centers_structure.preview.empty.no_hierarchy.description')}
          </Text.Normal>
        </Box>
      </Box>
    )
  }

  return (
    <Box flexGrow paddingTop="s16">
      <Box flexGrow paddingX="s24">
        <PreviewCostCenters treeArray={treeArray} jobStructure={jobStructure} />
      </Box>
    </Box>
  )
}

export { CostCentersPreview }
